import { useQuery } from 'react-query';

import { getHierarchyValues } from 'RestAPIs/hierarchy';

const useGetHierarchyValues = (startDate: string, endDate: string) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['hierarchy', 'list', startDate, endDate],
    async () => {
      const { data } = await getHierarchyValues(startDate, endDate);
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetHierarchyValues;
